import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SimpleChanges, OnInit, OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent implements OnInit, OnChanges {
  @Input() src!: string | null;
  @Input() alt!: string;
  @Input() defaultImage!: string;
  isLoading = true;
  finalImageSrc!: string;

  ngOnInit(): void {
    this.finalImageSrc = this.src || this.defaultImage;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = true;
    if (changes['src']) {
      this.finalImageSrc = this.src || this.defaultImage;
    }

    if (changes['src'].currentValue === null) {
      this.finalImageSrc = this.defaultImage;
      this.isLoading = false;
    }
  }

  onImageLoad(): void {
    this.isLoading = false;
  }

  onImageError(): void {
    this.finalImageSrc = this.defaultImage;
    this.isLoading = false;
  }
}
